(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-stories"] && !Shopify.designMode) return;
  try {
    
  class CreatorStories extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-creator-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-creator-panel]'));
      this.arrows = Array.from(this.querySelectorAll('[data-creator-direction]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.showPlatform(tab.dataset.creatorTab));
      });

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => this.scrollRail(Number(arrow.dataset.creatorDirection)));
      });

      this.querySelectorAll('[data-creator-rail]').forEach((rail) => {
        rail.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      });

      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.querySelectorAll('[data-creator-rail]').forEach((rail) => this.resizeObserver.observe(rail));

      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-creator-panel]');
        if (panel) this.showPlatform(panel.dataset.creatorPanel);
      });

      this.setupReveal();
      requestAnimationFrame(() => this.updateArrows());
    }

    disconnectedCallback() {
      this.revealObserver?.disconnect();
      this.resizeObserver?.disconnect();
    }

    activeRail() {
      return this.querySelector('[data-creator-panel]:not([hidden]) [data-creator-rail]');
    }

    showPlatform(platform) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.creatorTab === platform;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.creatorPanel !== platform;
      });

      requestAnimationFrame(() => this.updateArrows());
    }

    scrollRail(direction) {
      const rail = this.activeRail();
      if (!rail) return;

      const distance = Math.min(rail.clientWidth * 0.75, 440);
      rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    updateArrows() {
      const rail = this.activeRail();
      if (!rail) return;

      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      this.arrows.forEach((arrow) => {
        const direction = Number(arrow.dataset.creatorDirection);
        arrow.disabled = direction < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= maxScroll - 2;
      });
    }

    setupReveal() {
      const items = Array.from(this.querySelectorAll('[data-creator-card]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      this.classList.add('creator-stories--reveal-ready');
      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((item) => this.revealObserver.observe(item));
    }
  }

  if (!customElements.get('creator-stories')) {
    customElements.define('creator-stories', CreatorStories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-rc"] && !Shopify.designMode) return;
  try {
    
  class ImageWithTextRc extends HTMLElement {
    connectedCallback() {
      this.revealObserver?.disconnect();

      const revealTarget = this.querySelector('[data-reveal]');
      if (!revealTarget) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTarget.classList.add('is-visible');
        return;
      }

      this.classList.add('rc-reveal-ready');
      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            this.revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.14 }
      );

      this.revealObserver.observe(revealTarget);
    }

    disconnectedCallback() {
      this.revealObserver?.disconnect();
    }
  }

  if (!customElements.get('image-with-text-rc')) {
    customElements.define('image-with-text-rc', ImageWithTextRc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mission-showcase"] && !Shopify.designMode) return;
  try {
    
  class MissionShowcase extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.setupReveal();
      this.setupVideoPreviews();
    }

    setupReveal() {
      const revealItems = Array.from(this.querySelectorAll('[data-reveal]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      this.classList.add('mission-showcase--reveal-ready');
      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            this.revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.14 }
      );

      revealItems.forEach((item) => this.revealObserver.observe(item));
    }

    setupVideoPreviews() {
      const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const videoCards = Array.from(this.querySelectorAll('[data-video-card]'));

      if (!supportsHover || reduceMotion || videoCards.length === 0) return;

      this.videoAbortController = new AbortController();
      const listenerOptions = { signal: this.videoAbortController.signal };

      videoCards.forEach((card) => {
        const video = card.querySelector('.mission-showcase__video');
        if (!video) return;

        card.addEventListener('pointerenter', () => this.startVideoPreview(card), listenerOptions);
        card.addEventListener('pointerleave', () => this.stopVideoPreview(card), listenerOptions);
        video.addEventListener(
          'playing',
          () => {
            if (this.activeVideoCard === card) card.classList.add('is-video-visible');
          },
          listenerOptions
        );
        ['waiting', 'stalled', 'error'].forEach((eventName) => {
          video.addEventListener(eventName, () => card.classList.remove('is-video-visible'), listenerOptions);
        });
      });

      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.target === this.activeVideoCard) {
              this.stopVideoPreview(entry.target);
            }
          });
        });
        videoCards.forEach((card) => this.videoObserver.observe(card));
      }

      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) this.stopActiveVideo();
        },
        listenerOptions
      );
    }

    startVideoPreview(card) {
      if (this.activeVideoCard === card) return;

      this.stopActiveVideo();

      const video = card.querySelector('.mission-showcase__video');
      if (!video) return;

      if (!video.dataset.sourceLoaded) {
        video.querySelectorAll('source[data-video-source]').forEach((source) => {
          source.src = source.dataset.videoSource;
        });
        video.dataset.sourceLoaded = 'true';
        video.load();
      }

      this.activeVideoCard = card;
      video.muted = true;
      const playPromise = video.play();
      if (playPromise) {
        playPromise.catch(() => {
          if (this.activeVideoCard === card) card.classList.remove('is-video-visible');
        });
      }
    }

    stopVideoPreview(card) {
      if (this.activeVideoCard !== card) {
        card.classList.remove('is-video-visible');
        return;
      }

      this.stopActiveVideo();
    }

    stopActiveVideo() {
      const card = this.activeVideoCard;
      if (!card) return;

      const video = card.querySelector('.mission-showcase__video');
      card.classList.remove('is-video-visible');

      if (video) {
        video.pause();
        if (video.readyState > 0) {
          try {
            video.currentTime = 0;
          } catch (error) {
            // 部分浏览器在媒体尚未就绪时不允许重置播放位置。
          }
        }
      }

      this.activeVideoCard = null;
    }

    cleanup() {
      this.stopActiveVideo();
      this.revealObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.videoAbortController?.abort();
      this.revealObserver = null;
      this.videoObserver = null;
      this.videoAbortController = null;
    }

    disconnectedCallback() {
      this.cleanup();
    }
  }

  if (!customElements.get('mission-showcase')) {
    customElements.define('mission-showcase', MissionShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-rc"] && !Shopify.designMode) return;
  try {
    
  class NewsletterRc extends HTMLElement {
    connectedCallback() {
      this.revealObserver?.disconnect();
      this.revealTarget = this.querySelector('[data-newsletter-reveal]');

      if (!this.revealTarget) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        this.revealTarget.classList.add('is-visible');
        return;
      }

      this.classList.add('newsletter-rc--reveal-ready');
      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
      );

      this.revealObserver.observe(this.revealTarget);
    }

    disconnectedCallback() {
      this.revealObserver?.disconnect();
    }
  }

  if (!customElements.get('newsletter-rc')) {
    customElements.define('newsletter-rc', NewsletterRc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  class ProductListReveal extends HTMLElement {
    connectedCallback() {
      this.revealObserver?.disconnect();

      const revealItems = Array.from(this.querySelectorAll('[data-product-list-reveal]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      this.classList.add('product-list-reveal--ready');
      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            this.revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.14 }
      );

      revealItems.forEach((item) => this.revealObserver.observe(item));
    }

    disconnectedCallback() {
      this.revealObserver?.disconnect();
    }
  }

  if (!customElements.get('product-list-reveal')) {
    customElements.define('product-list-reveal', ProductListReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runcam-detail-features-grid"] && !Shopify.designMode) return;
  try {
    
  class RuncamGridReveal extends HTMLElement {
    connectedCallback() {
      this.revealObserver?.disconnect();
      this.classList.remove('rc-grid-reveal-ready');
      const blocks = Array.from(this.querySelectorAll('[data-rc-grid-reveal]'));
      if (!blocks.length || !('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('rc-grid-block-visible');
            this.revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.14 }
      );

      this.classList.add('rc-grid-reveal-ready');
      blocks.forEach((block, index) => {
        block.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
        if (!block.classList.contains('rc-grid-block-visible')) {
          this.revealObserver.observe(block);
        }
      });
    }

    disconnectedCallback() {
      this.revealObserver?.disconnect();
      this.classList.remove('rc-grid-reveal-ready');
    }
  }

  if (!customElements.get('runcam-grid-reveal')) {
    customElements.define('runcam-grid-reveal', RuncamGridReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runcam-detail-stay-in-game"] && !Shopify.designMode) return;
  try {
    
  class RuncamStayScene extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleDialogClick = this.handleDialogClick.bind(this);
      this.handleDialogClose = this.handleDialogClose.bind(this);
      this.handleRevealResize = this.handleRevealResize.bind(this);
      this.addEventListener('click', this.handleTriggerClick);
      this.setupDialog();
      this.setupReveal();
    }

    setupReveal() {
      this.classList.add('runcam-stay--motion-ready');
      if (this.hasRevealed) {
        this.classList.add('runcam-stay--stage-visible', 'runcam-stay--details-visible');
        return;
      }

      if (this.reduceMotion.matches || !('IntersectionObserver' in window)) {
        this.reveal();
        return;
      }

      this.revealTarget = this.querySelector('[data-stay-reveal-trigger]') || this;
      window.addEventListener('resize', this.handleRevealResize, { passive: true });
      this.createRevealObserver();
    }

    createRevealObserver() {
      this.revealObserver?.disconnect();

      const viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      const centerBandHeight = Math.min(viewportHeight, Math.max(64, Math.round(viewportHeight * 0.1)));
      const centerMargin = Math.max(0, Math.floor((viewportHeight - centerBandHeight) / 2));

      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.reveal();
          });
        },
        { rootMargin: `-${centerMargin}px 0px -${centerMargin}px 0px`, threshold: 0 }
      );
      this.revealObserver.observe(this.revealTarget);
    }

    handleRevealResize() {
      if (this.hasRevealed) return;
      if (this.revealResizeTimer) window.clearTimeout(this.revealResizeTimer);
      this.revealResizeTimer = window.setTimeout(() => this.createRevealObserver(), 120);
    }

    reveal() {
      if (this.hasRevealed) return;
      this.hasRevealed = true;
      this.revealObserver?.disconnect();
      window.removeEventListener('resize', this.handleRevealResize);
      this.classList.add('runcam-stay--stage-visible');
      if (this.reduceMotion.matches) {
        this.classList.add('runcam-stay--details-visible');
        return;
      }
      this.detailsTimer = window.setTimeout(() => {
        this.classList.add('runcam-stay--details-visible');
      }, 650);
    }

    setupDialog() {
      this.dialog = this.querySelector('[data-stay-dialog]');
      if (!this.dialog) return;
      this.dialog.addEventListener('click', this.handleDialogClick);
      this.dialog.addEventListener('close', this.handleDialogClose);
    }

    handleTriggerClick(event) {
      const closeButton = event.target.closest('[data-stay-dialog-close]');
      if (closeButton) {
        this.dialog?.close();
        return;
      }

      const trigger = event.target.closest('[data-stay-video-trigger]');
      if (!trigger || !this.dialog) return;

      const panel = Array.from(this.querySelectorAll('[data-stay-video-panel]')).find(
        (item) => item.dataset.stayVideoPanel === trigger.dataset.stayVideoTrigger
      );
      if (!panel) return;

      this.activeTrigger = trigger;
      this.querySelectorAll('[data-stay-video-panel]').forEach((item) => {
        item.hidden = item !== panel;
      });
      this.dialog.showModal();
      const video = panel.querySelector('video');
      video?.play().catch(() => {});
    }

    handleDialogClick(event) {
      if (event.target === this.dialog) this.dialog.close();
    }

    handleDialogClose() {
      this.querySelectorAll('.runcam-stay__video').forEach((video) => {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {
          // 媒体尚未就绪时，部分浏览器不允许重置播放位置。
        }
      });
      this.querySelectorAll('[data-stay-video-panel]').forEach((panel) => {
        panel.hidden = true;
      });
      this.activeTrigger?.focus();
      this.activeTrigger = null;
    }

    cleanup() {
      this.revealObserver?.disconnect();
      if (this.detailsTimer) window.clearTimeout(this.detailsTimer);
      if (this.revealResizeTimer) window.clearTimeout(this.revealResizeTimer);
      window.removeEventListener('resize', this.handleRevealResize);
      this.removeEventListener('click', this.handleTriggerClick);
      this.dialog?.removeEventListener('click', this.handleDialogClick);
      this.dialog?.removeEventListener('close', this.handleDialogClose);
      this.revealObserver = null;
      this.detailsTimer = null;
      this.revealResizeTimer = null;
      this.revealTarget = null;
    }

    disconnectedCallback() {
      this.cleanup();
    }
  }

  if (!customElements.get('runcam-stay-scene')) {
    customElements.define('runcam-stay-scene', RuncamStayScene);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-cards"] && !Shopify.designMode) return;
  try {
    
  class SupportCards extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.revealObserver?.disconnect();
      this.abortController = new AbortController();
      this.cards = Array.from(this.querySelectorAll('[data-support-card]'));
      this.rail = this.querySelector('[data-support-rail]');
      this.activeIndex = Math.max(0, this.cards.findIndex((card) => card.classList.contains('is-active')));
      this.pointerStartX = null;

      const signal = this.abortController.signal;

      this.cards.forEach((card, index) => {
        card.addEventListener('click', (event) => this.handleCardClick(event, index), { signal });
      });

      this.querySelectorAll('[data-support-direction]').forEach((button) => {
        button.addEventListener('click', () => this.showCard(this.activeIndex + Number(button.dataset.supportDirection)), { signal });
      });

      this.rail?.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.rail?.addEventListener('pointerdown', (event) => {
        this.pointerStartX = event.clientX;
      }, { signal });
      this.rail?.addEventListener('pointerup', (event) => this.handleSwipe(event), { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest?.('[data-support-card]');
        if (card) this.showCard(Number(card.dataset.cardIndex));
      }, { signal });

      this.showCard(this.activeIndex);
      this.setupReveal();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.revealObserver?.disconnect();
    }

    handleCardClick(event, index) {
      if (performance.now() < (this.ignoreClicksUntil || 0)) {
        event.preventDefault();
        return;
      }

      if (index !== this.activeIndex) {
        event.preventDefault();
        this.showCard(index, true);
        return;
      }

      if (!event.currentTarget.getAttribute('href') || event.currentTarget.getAttribute('href') === '#') {
        event.preventDefault();
      }
    }

    handleKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.showCard(this.activeIndex + (event.key === 'ArrowLeft' ? -1 : 1), true);
    }

    handleSwipe(event) {
      if (this.pointerStartX === null) return;
      const distance = event.clientX - this.pointerStartX;
      this.pointerStartX = null;
      if (Math.abs(distance) < 45) return;
      this.ignoreClicksUntil = performance.now() + 500;
      this.showCard(this.activeIndex + (distance < 0 ? 1 : -1));
    }

    showCard(index, focusCard = false) {
      if (!this.cards.length) return;
      const count = this.cards.length;
      this.activeIndex = (index + count) % count;

      this.cards.forEach((card, cardIndex) => {
        const offset = (cardIndex - this.activeIndex + count) % count;
        card.classList.remove('is-active', 'is-prev', 'is-next', 'is-far-prev', 'is-far-next');

        if (offset === 0) card.classList.add('is-active');
        else if (offset === 1) card.classList.add('is-next');
        else if (offset === count - 1) card.classList.add('is-prev');
        else if (offset === 2) card.classList.add('is-far-next');
        else if (offset === count - 2) card.classList.add('is-far-prev');

        const isActive = offset === 0;
        card.tabIndex = isActive ? 0 : -1;
        card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (focusCard) this.cards[this.activeIndex].focus({ preventScroll: true });
    }

    setupReveal() {
      const items = Array.from(this.querySelectorAll('[data-support-reveal]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      this.classList.add('support-cards--reveal-ready');
      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.revealObserver.unobserve(entry.target);
          });
        },
        { threshold: .14, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((item) => this.revealObserver.observe(item));
    }
  }

  if (!customElements.get('support-cards')) {
    customElements.define('support-cards', SupportCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-showcase"] && !Shopify.designMode) return;
  try {
    
  class TrustShowcase extends HTMLElement {
    connectedCallback() {
      this.revealObserver?.disconnect();
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);

      this.handleClick = (event) => {
        const card = event.target.closest('[data-trust-card]');
        const usesTap = window.matchMedia('(hover: none), (pointer: coarse), (max-width: 749px)').matches;

        if (card && this.contains(card) && usesTap) this.toggleCard(card);
      };

      this.handleKeydown = (event) => {
        const card = event.target.closest('[data-trust-card]');

        if (!card || !this.contains(card) || (event.key !== 'Enter' && event.key !== ' ')) return;

        event.preventDefault();
        this.toggleCard(card);
      };

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.initReveal();
    }

    disconnectedCallback() {
      this.revealObserver?.disconnect();
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    toggleCard(activeCard) {
      const shouldOpen = !activeCard.classList.contains('is-open');

      this.querySelectorAll('[data-trust-card]').forEach((card) => {
        const isOpen = card === activeCard && shouldOpen;
        card.classList.toggle('is-open', isOpen);
        card.setAttribute('aria-expanded', String(isOpen));
        card.querySelector('.trust-showcase__default')?.setAttribute('aria-hidden', String(isOpen));
        card.querySelector('.trust-showcase__hover')?.setAttribute('aria-hidden', String(!isOpen));
      });
    }

    initReveal() {
      const revealItems = Array.from(this.querySelectorAll('[data-reveal]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      this.classList.add('trust-showcase--reveal-ready');
      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            this.revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.14 }
      );

      revealItems.forEach((item) => this.revealObserver.observe(item));
    }
  }

  if (!customElements.get('trust-showcase')) {
    customElements.define('trust-showcase', TrustShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
